import { Flex, Text } from '@backyard-ui/core';

import { type ModularContent } from '@/infra/services/modular-content/model';

type Product = ModularContent.Product;

export interface StripeProps {
  /**
   *
   */
  discount?: Product['price']['discount'];

  /**
   *
   */
  isOutlet?: Product['meta']['isOutlet'];

  /**
   *
   */
  className?: string;
}

function Stripe(props: StripeProps) {
  const { discount, isOutlet, className, ...rest } = props;

  return (
    <Flex
      justify="space-between"
      className={className}
      data-testid="ProductThumb-stripe"
      {...rest}
    >
      <Text color="white" size="md" weight="bold" transform="uppercase" asChild>
        <span>Oferta</span>
      </Text>

      <Text color="white" size="md" weight="bold" asChild>
        <span>-{discount?.percentage}%</span>
      </Text>
    </Flex>
  );
}

export default Stripe;
